import { EnrichmentPlugin, Event } from '@amplitude/analytics-browser/lib/esm/types'

export const addEventMetaPlugin = (appName: string): EnrichmentPlugin => ({
  execute: async (event: Event) => {
    const isPortal = appName.toLowerCase() === 'portal'
    event.groups = {
      ...event.groups,
      organization: globalThis.window['ENV'].amplitude.orgId,
    }
    event.event_properties = {
      ...event.event_properties,
      app_name: appName,
      route: globalThis.window['ENV'].amplitude.routeId,
      user_agent: navigator.userAgent,
      source: 'UI',
      product_role: globalThis.window['ENV'].amplitude.productRole?.toLowerCase(),
      ...(isPortal && { portal_user_type: globalThis.window['ENV'].amplitude.userType?.toLowerCase() }),
    }
    return event
  },
})